import QzTray from './js/qztray';
import Printer from './js/printer';
import Scale from './js/scale';
import Scanner from './js/scanner';
import VueQzTrayControlComponent from './components/vue-qz-tray-control';
import VueQzTrayStatusComponent from './components/vue-qz-tray-status';

const QzTrayPlugin = {
    install(Vue, options) {
        if (! options) {
            options = {};
        }

        const qztray = new QzTray(options);
        const printer = new Printer(qztray);
        const scale = new Scale(qztray);
        const scanner = new Scanner(qztray);

        Vue.component('vue-qz-tray-control', VueQzTrayControlComponent);
        Vue.component('vue-qz-tray-status', VueQzTrayStatusComponent);

        Vue.qz = Vue.prototype.$qz = qztray;
        Vue.printer = Vue.prototype.$printer = printer;
        Vue.scale = Vue.prototype.$scale = scale;
        Vue.scanner = Vue.prototype.$scanner = scanner;
    }
};

export default QzTrayPlugin;
